import { FC, useState } from 'react';
import { SiPayModal } from 'utilities/components';
import { Button } from '../button/button.index';

export const DepositAddressModal: FC = () => {
    const [isOpen, setIsOpen] = useState<boolean>(true);

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <SiPayModal isOpen={isOpen} onClose={handleClose} disableCloseIcon title="تغییر آدرس‌های واریز تتر و ترون">
            <div className="w-full flex flex-col items-center justify-center">
                <span className="font-medium text-base text-black-100">
                    کاربران گرامی،
                    <br /> به‌منظور بروزرسانی امنیتی و زیرساخت کیف پول، آدرس‌های واریز تتر{' '}
                    <span className="en">(USDT)</span> و ترون <span className="en">(TRX)</span> شما در ۳۰پی تغییر کرده
                    است.
                </span>
                <br />
                <span className="font-medium text-base text-black-100">
                    لطفا قبل از هر واریز:
                    <br />
                    حتما از داخل حساب کاربری خود آدرس جدید واریز را دریافت کنید و از واریز به آدرس‌های قدیمی خودداری
                    کنید.
                </span>
                <div className="flex items-center w-full mt-8 gap-4">
                    <Button type={'primary'} className="w-full" onClick={handleClose}>
                        متوجه شدم
                    </Button>
                </div>
            </div>
        </SiPayModal>
    );
};
